module.exports = __webpack_public_path__ + "img/la-header.e5345892.png";